import type { IgnorableFn } from '~~/layers/datadog/composables/datadog'

export const DATADOG_IGNORABLE: IgnorableFn[] = [
  (_, _message, error) => {
    if (
      error &&
      typeof error === 'object' &&
      'cause' in error &&
      typeof error.cause === 'object' &&
      error.cause &&
      'message' in error.cause &&
      typeof error.cause.message === 'string'
    ) {
      return /AsyncData request cancelled by deduplication/i.test(
        error.cause.message,
      )
    }

    return false
  },
  (_, message) => message.includes('zoid destroyed all components'),
  (_, message) => /csp_violation/i.test(message),
  (_, message) => /evaluating 'a\.L'/i.test(message),
  (_, message) => /refused to/i.test(message),
]

export const DATADOG_STATES = {
  Player: 'datadog_player',
} as const
